import { useEffect, useRef } from "react";

const AUTO_LOGOUT_TIME = 20 * 60 * 1000; // 20분 (단위: ms)
// 테스트 5초
// const AUTO_LOGOUT_TIME = 5 * 1000;

export const useAutoLogout = (onLogout: () => void) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      // 로그아웃 처리
      onLogout();
    }, AUTO_LOGOUT_TIME);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];

    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer(); // 초기에 타이머 시작

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
};
